import { defineMessages } from 'react-intl';

export default defineMessages({
  // Grid messages
  errorLoadingData: {
    description: 'Error message when loading data fails',
    defaultMessage: 'Error loading forecasting data. Please try again.',
    id: 'K1r0xu',
  },
  noItemsToReorder: {
    description: 'Message when there are no items to reorder',
    defaultMessage: 'No items to reorder',
    id: '4Le61I',
  },

  // Grid column headers
  productNameColumnHeader: {
    description: 'Header for product name column',
    defaultMessage: 'Product',
    id: 'u2h6tQ',
  },
  currentOnHandColumnHeader: {
    description: 'Header for current on-hand column',
    defaultMessage: 'On Hand',
    id: 'VDhUma',
  },
  reorderThresholdColumnHeader: {
    description: 'Header for reorder threshold column',
    defaultMessage: 'Reorder Point',
    id: 'IXE2d+',
  },
  avgOrdersColumnHeader: {
    description: 'Header for average orders column',
    defaultMessage: 'Avg. Orders',
    id: 'ZWCcbl',
  },
  suggestedReorderColumnHeader: {
    description: 'Header for suggested reorder column',
    defaultMessage: 'Suggested',
    id: 'GhjGk7',
  },
  quantityColumnHeader: {
    description: 'Header for quantity column',
    defaultMessage: 'Quantity',
    id: 'L+I/jm',
  },

  // Expandable row messages
  expandRowAriaLabel: {
    description: 'Aria label for the expand row button',
    defaultMessage: 'Expand row to view velocity chart',
    id: 'L5hB1q',
  },
  collapseRowAriaLabel: {
    description: 'Aria label for the collapse row button',
    defaultMessage: 'Collapse row to hide velocity chart',
    id: 'EEBsWo',
  },
  showChart: {
    description: 'Text for the show chart link',
    defaultMessage: 'Show Chart',
    id: 'iNFxFX',
  },
  hideChart: {
    description: 'Text for the hide chart link',
    defaultMessage: 'Hide Chart',
    id: '9DkxNF',
  },

  // Velocity chart messages
  velocityChartYAxisLabel: {
    description: 'Y-axis label for the velocity chart',
    defaultMessage: 'Orders',
    id: 'DHDqr1',
  },
  velocityChartXAxisLabel: {
    description: 'X-axis label for the velocity chart',
    defaultMessage: 'Time',
    id: '9KW0Pn',
  },
  velocityChartHistoricalLabel: {
    description: 'Label for historical order data in the velocity chart',
    defaultMessage: 'Orders',
    id: 'nVm9Oc',
  },
  velocityChartForecastLabel: {
    description: 'Label for forecast data in the velocity chart',
    defaultMessage: 'Avg. Orders',
    id: 'zEuFVs',
  },
  stockLevelLabel: {
    description: 'Label for stock level data in the velocity chart',
    defaultMessage: 'Stock Level',
    id: 'kUChDt',
  },
  velocityChartNoDataMessage: {
    description: 'Message when there is no data for the velocity chart',
    defaultMessage: 'No velocity data available for this product',
    id: 'ubFBYI',
  },
  noHistoricalDataTitle: {
    description: 'Title for no historical data message',
    defaultMessage: 'No historical data',
    id: 'kCVNu4',
  },
  noHistoricalDataDescription: {
    description: 'Description for no historical data message',
    defaultMessage: 'At least 30 days of order history is required',
    id: 'z6ZURK',
  },
  velocityChartTodayLabel: {
    description: 'Label for the current day reference line in the velocity chart',
    defaultMessage: 'Today',
    id: 'z7z/sv',
  },

  // Product column
  skuLabel: {
    description: 'Label for SKU in product column',
    defaultMessage: 'SKU:',
    id: 'E2w90t',
  },

  // Quantity input
  quantityInputAriaLabel: {
    description: 'Aria label for quantity input field',
    defaultMessage: 'Order quantity',
    id: 'COOIjS',
  },
});
